import styled from 'styled-components';
import { MediumSectionHeader, Captions } from 'components/Typography';

const StyledMediumSectionHeader = styled(MediumSectionHeader)`
  && {
    margin-bottom: 4px;
    color: #fff;
  }
`;
const StyledCaptions = styled(Captions)`
  && {
    font-weight: 500;
    color: #fff;
    opacity: 0.56;
    margin-bottom: 0px;
  }
`;

export { StyledMediumSectionHeader, StyledCaptions };
